<template>
  <div class="role-box">
    <div class="role-title">请选择您的身份</div>
    <div class="role-all-item">
      <div
        class="role-item"
        v-for="(item, index) in roleArr"
        :key="index"
        :style="{
          'background-image': `url(${item.b})`,
          'background-repeat': 'no-repeat',
          'background-size': 'contain',
        }"
        :class="`role-item${index}`"
        @mouseenter="
          mouseEnterLeave(
            roleGsap,
            `.role-item${index}`,
            1.1,
            0.5,
            'power2.out'
          )
        "
        @mouseleave="
          mouseEnterLeave(roleGsap, `.role-item${index}`, 1, 0.5, 'power2.out')
        "
        @click="roleChange(item.v)"
      >
        <div class="role-mc">{{ item.t }}</div>
        <div class="role-jj">{{ item.d }}</div>
        <img
          v-if="item.v === `${yhlx}`"
          class="role-qr"
          src="@/assets/images/js-xz.png"
        />
        <div v-else class="role-qr"></div>
      </div>
    </div>
    <div class="close-icon-role" @click="close"><a-icon type="close" /></div>
  </div>
</template>
<script>
import { mixinAnimate } from "@/mixins/animate";
import store from "@/store";
import { putInfomationUplate } from "@/api/person-center";
import { message } from "ant-design-vue";
export default {
  mixins: [mixinAnimate],
  data() {
    return {
      yhlx: "4",
      user: null,
      roleArr: [
        // {
        //   t: "我是学生",
        //   v: "3",
        //   d: "切换此身份可用免费使用超好用的教学工具切换此身份可用免费使用超好用的教学工具",
        //   b: require("@/assets/images/ws-xs.png"),
        // },
        {
          t: "我是家长",
          v: "4",
          d: "切换此身份可用免费使用超好用的教学工具",
          b: require("@/assets/images/ws-jz.png"),
        },
        {
          t: "我是教师",
          v: "2",
          d: "切换此身份可用免费使用超好用的教学工具",
          b: require("@/assets/images/ws-js.png"),
        },
        // {
        //   t: "我是学校管理者",
        //   v: "1",
        //   d: "切换此身份可用免费使用超好用的教学工具",
        //   b: require("@/assets/images/ws-xxglz.png"),
        // },
        // {
        //   t: "我是行政单位管理者",
        //   v: "6",
        //   d: "切换此身份可用免费使用超好用的教学工具",
        //   b: require("@/assets/images/ws-bmglz.png"),
        // },
      ],
      roleGsap: null,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    roleChange(v) {
      const data = {
        ID: this.user.ID,
        SJH: this.user.SJH,
        XM: this.user.XM,
        YHLX: v,
        ZT: this.user.ZT,
      };
      putInfomationUplate(data).then((res) => {
        if (res) {
          if (res.code === 200) {
            message.success(res.message || "切换成功");
            this.$emit("success", data);
          } else {
            message.error(res.message || "切换失败");
          }
        }
      });
    },
  },
  mounted() {
    if (store.state.USERINFO) {
      this.user = store.state.USERINFO;

      if (store.state.USERINFO.YHLX) {
        this.yhlx = store.state.USERINFO.YHLX;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.role-box {
  width: 1200px;

  .role-title {
    width: 100%;
    font-weight: 400;
    font-size: 26px;
    color: #ffffff;
    text-align: center;
  }

  .role-all-item {
    margin-top: 43px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;

    .role-item {
      margin-bottom: 34px;
      margin-right: 24px;
      width: 384px;
      height: 104px;
      position: relative;

      .role-mc {
        position: absolute;
        top: 21px;
        left: 115px;
        font-weight: 600;
        font-size: 16px;
        color: #2b3138;
      }

      .role-jj {
        width: 183px;
        position: absolute;
        top: 46px;
        left: 115px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 19px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .role-qr {
        position: absolute;
        top: 44px;
        right: 19px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #dddddd;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }

  .close-icon-role {
    margin: 20px auto;
    width: 30px;
    height: 30px;
    font-size: 16px;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
